// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.ScheduledTab_tabContentHeader__2Q1XX {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px; }\n  .ScheduledTab_tabContentHeader__2Q1XX .ant-input-affix-wrapper {\n    max-width: 256px; }\n\n.ScheduledTab_pagination__2uMhY {\n  margin-top: 16px; }\n\n.ScheduledTab_highlightRow__2fCsU {\n  animation: ScheduledTab_highlightRow__2fCsU 6s 1; }\n\n@keyframes ScheduledTab_highlightRow__2fCsU {\n  0%,\n  99.95% {\n    background-color: #f8fcff; }\n  100% {\n    background-color: white; } }\n", ""]);
// Exports
exports.locals = {
	"tabContentHeader": "ScheduledTab_tabContentHeader__2Q1XX",
	"pagination": "ScheduledTab_pagination__2uMhY",
	"highlightRow": "ScheduledTab_highlightRow__2fCsU"
};
module.exports = exports;
